import EPButton from "components/UI/EPButton";
import React from "react";
import { useRouter } from "next/router";
import LeaderboardSVG from "public/svgs/leaderboard-active.svg";
function ViewGameLeaderBoardButton({ game, noTextOnMobile }) {
  const router = useRouter();
  const handleViewLeaderboard = () => {
    const gameId = game?.ws?.gid;
    router.push({
      pathname: "/leaderboard",
      query: {
        game: gameId,
      },
    });
  };

  return (
    <EPButton
      variant="primary"
      onClick={handleViewLeaderboard}
      className="flex h-full w-full items-center justify-center gap-2"
    >
      <LeaderboardSVG alt="leaderboard" width={30} height={30} /> View
      Leaderboard
    </EPButton>
  );
}

export default ViewGameLeaderBoardButton;
